import II18 from '../../translate/II18';
import SignPad from './SignPad';
import { PageContent, Sheet } from 'framework7-react';
import PropTypes from 'prop-types';
import React from 'react';

const SignPadDialog = props => {
  const {
    opened,
    signatureElement,
    onClose,
    documentName,
    onSignatureDone,
    onCancel
  } = props;

  const onToSmall = () =>
    this.$f7.dialog.alert(
      II18.get('cropper_is_to_small_message'),
      II18.get('dialog_warning')
    );
  return (
    <Sheet
      closeByBackdropClick={false}
      closeByOutsideClick={false}
      closeOnEscape={false}
      onSheetClosed={onClose}
      opened={opened}
      id={'signatureSheet'}
      className={'signatureSheet desktopSignaturePad'}
      style={{
        '--f7-sheet-bg-color': '#fff'
      }}
    >
      <PageContent>
        <div className={'signatureLayer'}>
          {signatureElement !== false && (
            <SignPad
              popupOpened={opened}
              onToSmall={onToSmall}
              docName={documentName}
              title={signatureElement?.label}
              onDone={onSignatureDone}
              onCancel={onCancel}
            />
          )}
        </div>
      </PageContent>
    </Sheet>
  );
};

SignPadDialog.propTypes = {
  opened: PropTypes.bool,
  signatureElement: PropTypes.object,
  onClose: PropTypes.func,
  documentName: PropTypes.string,
  onSignatureDone: PropTypes.func,
  onCancel: PropTypes.func
};

export default SignPadDialog;
